"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _ButtonUploadExcel = _interopRequireDefault(require("@/components/ButtonUploadExcel"));
var _selectStaff = _interopRequireDefault(require("./selectStaff.vue"));
var _componentsApi = require("@/api/componentsApi");
var _api = require("../api");
var _validate = require("@/utils/validate");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _regenerator() { /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/babel/babel/blob/main/packages/babel-helpers/LICENSE */ var e, t, r = "function" == typeof Symbol ? Symbol : {}, n = r.iterator || "@@iterator", o = r.toStringTag || "@@toStringTag"; function i(r, n, o, i) { var c = n && n.prototype instanceof Generator ? n : Generator, u = Object.create(c.prototype); return _regeneratorDefine2(u, "_invoke", function (r, n, o) { var i, c, u, f = 0, p = o || [], y = !1, G = { p: 0, n: 0, v: e, a: d, f: d.bind(e, 4), d: function d(t, r) { return i = t, c = 0, u = e, G.n = r, a; } }; function d(r, n) { for (c = r, u = n, t = 0; !y && f && !o && t < p.length; t++) { var o, i = p[t], d = G.p, l = i[2]; r > 3 ? (o = l === n) && (u = i[(c = i[4]) ? 5 : (c = 3, 3)], i[4] = i[5] = e) : i[0] <= d && ((o = r < 2 && d < i[1]) ? (c = 0, G.v = n, G.n = i[1]) : d < l && (o = r < 3 || i[0] > n || n > l) && (i[4] = r, i[5] = n, G.n = l, c = 0)); } if (o || r > 1) return a; throw y = !0, n; } return function (o, p, l) { if (f > 1) throw TypeError("Generator is already running"); for (y && 1 === p && d(p, l), c = p, u = l; (t = c < 2 ? e : u) || !y;) { i || (c ? c < 3 ? (c > 1 && (G.n = -1), d(c, u)) : G.n = u : G.v = u); try { if (f = 2, i) { if (c || (o = "next"), t = i[o]) { if (!(t = t.call(i, u))) throw TypeError("iterator result is not an object"); if (!t.done) return t; u = t.value, c < 2 && (c = 0); } else 1 === c && (t = i.return) && t.call(i), c < 2 && (u = TypeError("The iterator does not provide a '" + o + "' method"), c = 1); i = e; } else if ((t = (y = G.n < 0) ? u : r.call(n, G)) !== a) break; } catch (t) { i = e, c = 1, u = t; } finally { f = 1; } } return { value: t, done: y }; }; }(r, o, i), !0), u; } var a = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} t = Object.getPrototypeOf; var c = [][n] ? t(t([][n]())) : (_regeneratorDefine2(t = {}, n, function () { return this; }), t), u = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(c); function f(e) { return Object.setPrototypeOf ? Object.setPrototypeOf(e, GeneratorFunctionPrototype) : (e.__proto__ = GeneratorFunctionPrototype, _regeneratorDefine2(e, o, "GeneratorFunction")), e.prototype = Object.create(u), e; } return GeneratorFunction.prototype = GeneratorFunctionPrototype, _regeneratorDefine2(u, "constructor", GeneratorFunctionPrototype), _regeneratorDefine2(GeneratorFunctionPrototype, "constructor", GeneratorFunction), GeneratorFunction.displayName = "GeneratorFunction", _regeneratorDefine2(GeneratorFunctionPrototype, o, "GeneratorFunction"), _regeneratorDefine2(u), _regeneratorDefine2(u, o, "Generator"), _regeneratorDefine2(u, n, function () { return this; }), _regeneratorDefine2(u, "toString", function () { return "[object Generator]"; }), (_regenerator = function _regenerator() { return { w: i, m: f }; })(); }
function _regeneratorDefine2(e, r, n, t) { var i = Object.defineProperty; try { i({}, "", {}); } catch (e) { i = 0; } _regeneratorDefine2 = function _regeneratorDefine(e, r, n, t) { function o(r, n) { _regeneratorDefine2(e, r, function (e) { return this._invoke(r, n, e); }); } r ? i ? i(e, r, { value: n, enumerable: !t, configurable: !t, writable: !t }) : e[r] = n : (o("next", 0), o("throw", 1), o("return", 2)); }, _regeneratorDefine2(e, r, n, t); }
function asyncGeneratorStep(n, t, e, r, o, a, c) { try { var i = n[a](c), u = i.value; } catch (n) { return void e(n); } i.done ? t(u) : Promise.resolve(u).then(r, o); }
function _asyncToGenerator(n) { return function () { var t = this, e = arguments; return new Promise(function (r, o) { var a = n.apply(t, e); function _next(n) { asyncGeneratorStep(a, r, o, _next, _throw, "next", n); } function _throw(n) { asyncGeneratorStep(a, r, o, _next, _throw, "throw", n); } _next(void 0); }); }; } //
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var _default2 = exports.default = {
  components: {
    ButtonUploadExcel: _ButtonUploadExcel.default,
    SelectStaff: _selectStaff.default
  },
  props: {
    companies: {
      type: Array,
      default: function _default() {
        return [];
      }
    }
  },
  data: function data() {
    return {
      dialogFormVisible: false,
      title: '新增客户',
      form: {
        customerEmpList: [],
        integralLogId: null,
        // 选中的发放批次
        projectNumber: '',
        // 项目编号
        companyId: '',
        // 公司ID
        salesPrice: 0,
        // 销售价
        reason: '',
        // 回收原因
        remark: '',
        // 内部备注
        innerRemark: '' // 备注
      },
      pageFrom: {
        page: 1,
        limit: 999,
        id: null
      },
      tableData: {
        total: 0,
        list: []
      },
      fdata: {},
      sendLogLists: [],
      submitting: false,
      loadingSendLogs: false,
      // 发放批次加载状态
      isUpdatingSendLogs: false,
      // 标记是否正在更新发放批次列表，避免watch干扰用户选择
      isMigrationBatch: false,
      // 当前选中批次是否为数据迁移批次
      // 表单验证规则
      rules: {
        reason: [{
          required: true,
          message: '请输入回收原因',
          trigger: 'blur'
        }],
        integralLogId: [{
          required: true,
          message: '请选择发放批次',
          trigger: 'change'
        }]
      }
    };
  },
  computed: {
    companyOptions: function companyOptions() {
      return (this.companies || []).map(function (item) {
        return {
          id: item.id,
          name: item.name || ''
        };
      }).filter(function (item) {
        return item.name;
      });
    }
  },
  watch: {
    'form.integralLogId': function formIntegralLogId(val) {
      this.updateSalesPrice();
      this.updateCompanyByIntegralLog(val);
    },
    'form.customerEmpList': {
      handler: function handler() {
        this.updateSalesPrice();
      },
      deep: true
    },
    // 监听员工列表变化，在全员回收模式下重新计算销售价
    'tableData.list': {
      handler: function handler() {
        // 仅在全员回收模式下触发计算
        if (this.form.customerEmpType === 1) {
          this.updateSalesPrice();
        }
      },
      deep: true
    }
  },
  created: function created() {
    this.debouncedSubmit = (0, _validate.Debounce)(this.submit, 500);
  },
  methods: {
    // 员工选择弹窗更新回调
    handleStaffUpdate: function handleStaffUpdate(data) {
      this.form.customerEmpList = data;
      // 根据选择的员工更新发放批次
      var _ref = this.fdata || {},
        customerId = _ref.customerId,
        integralId = _ref.integralId;
      if (customerId && integralId) {
        var empIds = data && data.length > 0 ? data.map(function (item) {
          return item.id;
        }).filter(function (id) {
          return id;
        }).sort() : [];
        this.form.integralLogId = null;
        this.initPage({
          customerId: customerId,
          integralId: integralId,
          empIds: empIds
        });
      }
      this.updateSalesPrice();
    },
    // 打开员工选择弹窗
    openSelectStaff: function openSelectStaff() {
      if (this.form.customerEmpType !== 2) return;
      this.$refs.selectStaffRef.open(this.fdata.customerId, this.fdata.integralId);
    },
    // 移除已选员工
    removeSelectedStaff: function removeSelectedStaff(item) {
      this.form.customerEmpList = this.form.customerEmpList.filter(function (emp) {
        return emp.id !== item.id;
      });
      // 更新发放批次
      var _ref2 = this.fdata || {},
        customerId = _ref2.customerId,
        integralId = _ref2.integralId;
      if (customerId && integralId) {
        var empIds = this.form.customerEmpList.length > 0 ? this.form.customerEmpList.map(function (emp) {
          return emp.id;
        }).filter(function (id) {
          return id;
        }).sort() : [];
        this.form.integralLogId = null;
        this.initPage({
          customerId: customerId,
          integralId: integralId,
          empIds: empIds
        });
      }
      this.updateSalesPrice();
    },
    // 指定回收员工选择变更（保留用于批量上传模式）
    handleEmpSelectChange: function handleEmpSelectChange(newVal) {
      // 如果正在更新发放批次列表，跳过，避免干扰用户选择
      if (this.isUpdatingSendLogs) {
        return;
      }
      // 仅在指定回收模式下处理
      if (this.form.customerEmpType !== 2) {
        return;
      }
      var _ref3 = this.fdata || {},
        customerId = _ref3.customerId,
        integralId = _ref3.integralId;
      if (!customerId || !integralId) {
        return;
      }
      var empIds = newVal && newVal.length > 0 ? newVal.map(function (item) {
        return item.id;
      }).filter(function (id) {
        return id;
      }).sort() : [];
      // 触发监听时清空已选发放批次
      this.form.integralLogId = null;
      // 发送请求，空数组表示获取全部数据
      this.initPage({
        customerId: customerId,
        integralId: integralId,
        empIds: empIds
      });
      // 更新销售价
      this.updateSalesPrice();
    },
    // 回收方式切换
    handleEmpTypeChange: function handleEmpTypeChange(val) {
      // 重置员工选择与发放批次
      this.form.customerEmpList = [];
      this.form.integralLogId = null;

      // 仅当有必要参数时才请求
      var _ref4 = this.fdata || {},
        customerId = _ref4.customerId,
        integralId = _ref4.integralId;
      if (!customerId || !integralId) {
        return;
      }

      // 类型1或3：获取全部发放批次
      if (val === 1 || val === 3) {
        this.initPage({
          customerId: customerId,
          integralId: integralId,
          empIds: []
        });
      }
      // 类型2：不立即请求，等待选择员工后动态加载
      this.updateSalesPrice();
    },
    open: function open(data) {
      this.fdata = data || {};
      // 重置表单，确保数据隔离
      this.form = {
        customerEmpType: 2,
        // 默认指定回收
        customerEmpList: [],
        integralLogId: null,
        projectNumber: '',
        companyId: '',
        salesPrice: 0,
        reason: '',
        remark: '',
        innerRemark: ''
      };
      this.sendLogLists = [];
      this.getInfo();
      this.dialogFormVisible = true;
      this.updateSalesPrice();
    },
    close: function close() {
      this.form = {
        customerEmpType: 2,
        customerEmpList: [],
        integralLogId: null,
        // 重置发放批次
        projectNumber: '',
        // 重置项目编号
        companyId: '',
        // 重置公司ID
        salesPrice: 0,
        // 重置销售价
        reason: '',
        // 重置回收原因
        remark: '',
        // 重置内部备注
        innerRemark: '' // 重置备注
      };
      this.loadingSendLogs = false;
      this.isMigrationBatch = false;
      this.submitting = false;
      this.dialogFormVisible = false;
    },
    download: function () {
      var _download = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee() {
        var res, _t;
        return _regenerator().w(function (_context) {
          while (1) switch (_context.p = _context.n) {
            case 0:
              _context.p = 0;
              _context.n = 1;
              return (0, _componentsApi.excelTemplateApi)('import_emp.xlsx');
            case 1:
              res = _context.v;
              window.open(res.fileName);
              _context.n = 3;
              break;
            case 2:
              _context.p = 2;
              _t = _context.v;
            case 3:
              return _context.a(2);
          }
        }, _callee, null, [[0, 2]]);
      }));
      function download() {
        return _download.apply(this, arguments);
      }
      return download;
    }(),
    //上传文件
    onSuccess: function onSuccess(excelData) {
      var results = excelData.results;
      var arr = [];
      results.forEach(function (item) {
        var values = Object.values(item);
        arr.push({
          empName: values[0],
          phone: values[1],
          empNo: values[2],
          wechat: values[3],
          dept: values[4],
          title: values[5]
        });
      });
      this.form.customerEmpList = arr;
      this.$message.success('导入成功');
    },
    updateSalesPrice: function updateSalesPrice() {
      var _this = this;
      var selected = this.sendLogLists.find(function (item) {
        return item.integralLogId === _this.form.integralLogId;
      });
      // 发放批次尚未匹配到时，不覆盖用户已经填写的销售价
      var unit_sales_price = selected ? Number(selected.unit_sales_price) : 0;

      // 根据回收方式计算员工数量
      var count = 0;
      if (this.form.customerEmpType === 1) {
        // 全员回收：使用所有员工数量
        count = Array.isArray(this.tableData.list) ? this.tableData.list.length : 0;
      } else {
        // 指定回收或指定员工批量：使用已选员工数量
        count = Array.isArray(this.form.customerEmpList) ? this.form.customerEmpList.length : 0;
      }
      this.form.salesPrice = Number((unit_sales_price * count).toFixed(2));
    },
    getInfo: function () {
      var _getInfo = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee2() {
        var params, res, _t2;
        return _regenerator().w(function (_context2) {
          while (1) switch (_context2.p = _context2.n) {
            case 0:
              params = _objectSpread(_objectSpread(_objectSpread({}, this.pageFrom), this.fdata), {}, {
                id: this.fdata.customerId,
                customerIntegralId: this.fdata.integralId
              });
              _context2.p = 1;
              _context2.n = 2;
              return (0, _api.empListApi)(params);
            case 2:
              res = _context2.v;
              this.tableData = res;
              _context2.n = 4;
              break;
            case 3:
              _context2.p = 3;
              _t2 = _context2.v;
              this.$message.error(_t2.message);
            case 4:
              return _context2.a(2);
          }
        }, _callee2, this, [[1, 3]]);
      }));
      function getInfo() {
        return _getInfo.apply(this, arguments);
      }
      return getInfo;
    }(),
    submit: function () {
      var _submit = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee4() {
        var _this2 = this;
        return _regenerator().w(function (_context4) {
          while (1) switch (_context4.n) {
            case 0:
              if (!this.submitting) {
                _context4.n = 1;
                break;
              }
              return _context4.a(2);
            case 1:
              // 表单验证
              this.$refs.formRef.validate(/*#__PURE__*/function () {
                var _ref5 = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee3(valid) {
                  var params, _this2$sendLogLists, idx, _ref6, integral;
                  return _regenerator().w(function (_context3) {
                    while (1) switch (_context3.p = _context3.n) {
                      case 0:
                        if (valid) {
                          _context3.n = 1;
                          break;
                        }
                        return _context3.a(2, false);
                      case 1:
                        if (!_this2.submitting) {
                          _context3.n = 2;
                          break;
                        }
                        return _context3.a(2);
                      case 2:
                        _this2.submitting = true;
                        params = _objectSpread(_objectSpread(_objectSpread({}, _this2.fdata), _this2.form), {}, {
                          type: 2,
                          exeType: 1,
                          customerIntegralId: _this2.fdata.id
                        });
                        params.salesPrice = Number(_this2.form.salesPrice || 0);
                        params.customerEmpType = _this2.form.customerEmpType === 1 ? 2 : 4;
                        if (params !== null && params !== void 0 && params.integralLogId) {
                          idx = (_this2$sendLogLists = _this2.sendLogLists) === null || _this2$sendLogLists === void 0 ? void 0 : _this2$sendLogLists.findIndex(function (item) {
                            return item.integralLogId == (params === null || params === void 0 ? void 0 : params.integralLogId);
                          });
                          _ref6 = _this2.sendLogLists[idx] || {}, integral = _ref6.integral;
                          params['integral'] = integral;
                        }
                        _context3.p = 3;
                        _context3.n = 4;
                        return (0, _api.integralLogSaveApi)(params);
                      case 4:
                        _this2.$message.success('回收成功');
                        _this2.close();
                        _this2.$emit('refresh');
                      case 5:
                        _context3.p = 5;
                        _this2.submitting = false;
                        return _context3.f(5);
                      case 6:
                        return _context3.a(2);
                    }
                  }, _callee3, null, [[3,, 5, 6]]);
                }));
                return function (_x) {
                  return _ref5.apply(this, arguments);
                };
              }());
            case 2:
              return _context4.a(2);
          }
        }, _callee4, this);
      }));
      function submit() {
        return _submit.apply(this, arguments);
      }
      return submit;
    }(),
    initPage: function () {
      var _initPage = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee5(data) {
        var _this3 = this;
        var res, _t3;
        return _regenerator().w(function (_context5) {
          while (1) switch (_context5.p = _context5.n) {
            case 0:
              // 设置标记，防止更新列表期间触发干扰
              this.isUpdatingSendLogs = true;
              // 设置加载状态，禁用选择框
              this.loadingSendLogs = true;
              this.sendLogLists = [];
              _context5.p = 1;
              _context5.n = 2;
              return (0, _api.getSendLogs)(data);
            case 2:
              res = _context5.v;
              this.sendLogLists = res || [];

              // 请求成功后提示（只有在指定回收模式下且有员工选择时才提示）
              if (this.form.customerEmpType === 2 && data.empIds && data.empIds.length > 0) {
                this.$message.success('发放批次已关联更新');
              }
              _context5.n = 4;
              break;
            case 3:
              _context5.p = 3;
              _t3 = _context5.v;
              this.$message.error(_t3.message || '获取发放批次失败');
            case 4:
              _context5.p = 4;
              // 请求完成后，恢复选择框可用状态
              this.loadingSendLogs = false;
              // 延迟重置标记，确保所有响应式更新完成
              this.$nextTick(function () {
                _this3.isUpdatingSendLogs = false;
              });
              return _context5.f(4);
            case 5:
              return _context5.a(2);
          }
        }, _callee5, this, [[1, 3, 4, 5]]);
      }));
      function initPage(_x2) {
        return _initPage.apply(this, arguments);
      }
      return initPage;
    }(),
    // 发放批次选择变更处理
    handleIntegralLogChange: function handleIntegralLogChange(val) {
      this.updateCompanyByIntegralLog(val);
      this.isMigrationBatch = false;
      if (val) {
        var selected = this.sendLogLists.find(function (item) {
          return item.integralLogId === val;
        });
        if (selected && selected.sendType === 8) {
          this.isMigrationBatch = true;
        }
      }
    },
    // 根据发放批次更新公司
    updateCompanyByIntegralLog: function updateCompanyByIntegralLog(integralLogId) {
      if (!integralLogId) {
        // 如果清空了发放批次，也清空公司选择
        this.form.companyId = '';
        return;
      }
      // 从 sendLogLists 中查找对应的发放批次
      var selectedLog = this.sendLogLists.find(function (item) {
        return item.integralLogId === integralLogId;
      });
      if (selectedLog && selectedLog.company_id) {
        // 设置公司ID
        this.form.companyId = selectedLog.company_id;
      } else {
        // 如果没有找到对应的公司ID，清空公司选择
        this.form.companyId = '';
      }
    }
  }
};